"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _configure = require("@/api/configure.js");
var _dictionary = require("@/config/dictionary");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _index = require("@/utils/index.js");
var _security = require("@/utils/security");
var _encryptKey = require("@/config/encryptKey");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'documentManagement',
  data: function data() {
    return {
      tableHeaderColor: this.$tableHeaderColor,
      statevalue: '',
      //状态值
      stateArr: [{
        //状态数组
        value: '1',
        label: '已启用'
      }, {
        value: '0',
        label: '已禁用'
      }],
      committeeValue: '',
      //所属仲裁委值
      committeeArr: [],
      sendArr: [{
        label: '短信',
        value: '1'
      }, {
        label: '邮件',
        value: '2'
      }],
      //送达类型数组
      sendval: '',
      //送达类型值
      relatedDocArr: [],
      //关联文书数组
      caseStatusArr: [],
      //案件状态数组
      temlval: '',
      //模板值
      loading: true,
      tableData: [],
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      total: 0,
      caseSendType: _dictionary.dictionary.caseSendType,
      partyIdType: _dictionary.dictionary.partyIdType,
      templateVisible: false,
      //文书弹窗显示
      title: '',
      //弹窗标题
      temForm: {
        //模板数据
        organ: '',
        relateBook: '',
        contentOfEmail: '',
        contentOfMess: '',
        name: '',
        status: "启用",
        partyType: '',
        caseState: ''
      },
      message: '',
      temFormRules: {
        organ: [{
          required: true,
          message: '请选择'
        }],
        caseState: [{
          required: true,
          message: '请选择'
        }],
        name: [{
          required: true,
          message: '请输入'
        }],
        status: [{
          required: true,
          message: '请选择'
        }],
        partyType: [{
          required: true,
          message: '请输入'
        }]
      },
      currentId: '',
      //当前表格行id
      // partyTypeArr:[{id:1,name:'申请人'},{id:2,name:"被申请人"},{id:3,name:"代理人"},{id:4,name:"申请人代理人"},{id:5,name:"被申请人代理人"}],
      partyTypeArr: [],
      fileList: [],
      action: process.env.VUE_APP_BASE_API + (0, _configure.uploadFileCommonURL)(),
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      params: {}
    };
  },
  components: {
    Tinymce: _Tinymce.default
  },
  created: function created() {
    var _this = this;
    this.currentPage = 1;
    this.init();
    //仲裁委员会列表
    (0, _configure.getAllCommission)().then(function (res) {
      if (res.code == 1) {
        _this.committeeArr = res.data;
      }
    });
  },
  mounted: function mounted() {
    for (var key in this.partyIdType) {
      this.partyTypeArr.push({
        id: key,
        name: this.partyIdType[key]
      });
    }
  },
  methods: {
    // 初始化
    init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _yield$getcaseSendTem, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _configure.getcaseSendTemplateList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 2:
              _yield$getcaseSendTem = _context.sent;
              rows = _yield$getcaseSendTem.rows;
              total = _yield$getcaseSendTem.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    //重置列表
    resetTableList: function () {
      var _resetTableList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _yield$getcaseSendTem2, rows, total, _yield$getcaseSendTem3, _rows, _total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.statevalue || this.committeeValue)) {
                _context2.next = 11;
                break;
              }
              _context2.next = 3;
              return (0, _configure.getcaseSendTemplateList)({
                commId: this.committeeValue,
                status: this.statevalue,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 3:
              _yield$getcaseSendTem2 = _context2.sent;
              rows = _yield$getcaseSendTem2.rows;
              total = _yield$getcaseSendTem2.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
              _context2.next = 19;
              break;
            case 11:
              _context2.next = 13;
              return (0, _configure.getcaseSendTemplateList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 13:
              _yield$getcaseSendTem3 = _context2.sent;
              _rows = _yield$getcaseSendTem3.rows;
              _total = _yield$getcaseSendTem3.total;
              this.tableData = _rows;
              this.total = _total;
              this.loading = false;
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function resetTableList() {
        return _resetTableList.apply(this, arguments);
      }
      return resetTableList;
    }(),
    //添加文书
    gotoCreate: function gotoCreate() {
      this.templateVisible = true;
      this.title = "添加送达模板";
      this.relatedDocArr = [];
      this.caseStatusArr = [];
      this.temForm.relateBook = '';
      this.temForm.contentOfEmail = '';
      this.temForm.contentOfMess = '';
      this.fileList = [];
      if (this.$refs['temForm']) {
        this.$refs['temForm'].resetFields();
      }
    },
    //筛选
    screen: function () {
      var _screen = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _yield$getcaseSendTem4, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.total = 1;
              this.currentPage = 1;
              if (!(this.sendval || this.statevalue || this.committeeValue || this.temlval)) {
                _context3.next = 11;
                break;
              }
              _context3.next = 5;
              return (0, _configure.getcaseSendTemplateList)({
                commId: this.committeeValue,
                status: this.statevalue,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 5:
              _yield$getcaseSendTem4 = _context3.sent;
              rows = _yield$getcaseSendTem4.rows;
              total = _yield$getcaseSendTem4.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function screen() {
        return _screen.apply(this, arguments);
      }
      return screen;
    }(),
    //点击 清空所有筛选条件
    clearAllConditon: function clearAllConditon() {
      this.statevalue = '';
      this.sendval = "";
      this.committeeValue = "";
      this.temlval = "";
      this.currentPage = 1;
      this.init();
    },
    //表格   删除
    deleteRow: function deleteRow(val) {
      var _this2 = this;
      this.$confirm('是否删除该送达模板？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _configure.deleteCaseSendTemplate)({
          id: val.id
        }).then(function (res) {
          if (res.code == 1) {
            _this2.$message({
              message: '删除成功',
              type: 'success'
            });
            _this2.resetTableList();
          }
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 所属仲裁委发生变化时
    choosenCommitt: function choosenCommitt(val) {
      var _this3 = this;
      var committeeItem = this.committeeArr.find(function (ele) {
        return ele.name == val;
      });
      // 案件文书列表
      (0, _configure.getcaseRelatedBookList)({
        commId: committeeItem.id
      }).then(function (res) {
        if (res.code == 1) {
          _this3.relatedDocArr = res.data;
        } else {
          _this3.$message.error(res.msg);
        }
      });
      (0, _configure.getProcesscaseStateList)({
        commId: committeeItem.id
      }).then(function (res) {
        if (res.code == 1) {
          _this3.caseStatusArr = res.data;
        } else {
          _this3.$message.error(res.msg);
        }
      });
    },
    //表格  编辑
    edit: function edit(val) {
      var _this4 = this;
      this.currentId = val.id;
      this.params = {
        commId: val.commId
      };
      this.templateVisible = true;
      this.fileList = [];
      this.title = '编辑送达模板';
      if (this.$refs['temForm']) {
        this.$refs['temForm'].resetFields();
      }
      var promise1 = (0, _configure.getProcesscaseStateList)({
        commId: val.commId
      });
      var promise2 = (0, _configure.checkCaseSendTemplate)({
        id: val.id
      });
      var committeeItem;
      var caseItem;
      var realtedBookItem;
      var caseBookId;
      Promise.all([promise1, promise2]).then(function (res) {
        _this4.caseStatusArr = res[0].data;
        committeeItem = _this4.committeeArr.find(function (ele) {
          return ele.id == res[1].data.commId;
        });
        caseItem = _this4.caseStatusArr.find(function (ele) {
          return ele.status == res[1].data.caseState;
        });
        _this4.temForm.partyType = _this4.partyIdType[res[1].data.partyType];
        _this4.temForm.name = res[1].data.templateName;
        _this4.temForm.contentOfEmail = res[1].data.emailTemplate;
        _this4.temForm.contentOfMess = res[1].data.smsTemplate;
        _this4.temForm.status = res[1].data.status == 1 ? "启用" : '禁用';
        _this4.temForm.organ = committeeItem.name;
        _this4.temForm.caseState = caseItem.name;
        res[1].data.sendFileHref.forEach(function (ele) {
          _this4.fileList.push({
            url: ele.href,
            filePath: ele.filePath,
            name: ele.fileName
          });
        });
        caseBookId = res[1].data.caseBookId;
      }).then(function () {
        (0, _configure.getcaseRelatedBookList)({
          commId: committeeItem.id
        }).then(function (res1) {
          _this4.relatedDocArr = res1.data;
          realtedBookItem = _this4.relatedDocArr.find(function (ele) {
            return ele.id == caseBookId;
          });
          _this4.temForm.relateBook = realtedBookItem.templateName;
        });
      });
    },
    //人员修改/添加提交表单
    submitTemForm: function submitTemForm(formName) {
      var _this5 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var committeeItem = _this5.committeeArr.find(function (ele) {
            return ele.name == _this5.temForm.organ;
          });
          var realtedBookItem = _this5.relatedDocArr.find(function (ele) {
            return ele.templateName == _this5.temForm.relateBook;
          });
          var partyTypeItem = _this5.partyTypeArr.find(function (ele) {
            return ele.name == _this5.temForm.partyType;
          });
          var caseItem = _this5.caseStatusArr.find(function (ele) {
            return ele.name == _this5.temForm.caseState;
          });
          var postFilelist = [];
          _this5.fileList.forEach(function (ele) {
            postFilelist.push(ele.filePath);
          });
          if (_this5.title == '添加送达模板') {
            (0, _configure.addCaseSendTemplate)({
              caseBookId: realtedBookItem.id,
              templateName: _this5.temForm.name,
              smsTemplate: _this5.temForm.contentOfMess,
              emailTemplate: _this5.temForm.contentOfEmail,
              status: _this5.temForm.status == "启用" ? '1' : '0',
              caseState: caseItem.status,
              commId: committeeItem.id,
              commName: _this5.temForm.organ,
              partyType: partyTypeItem.id,
              sendFile: postFilelist.join()
            }).then(function (res) {
              if (res.code == 1) {
                _this5.$message({
                  message: '添加送达模板成功',
                  type: 'success'
                });
                _this5.templateVisible = false;
                _this5.$refs[formName].resetFields();
                _this5.resetTableList();
              }
            });
          } else {
            (0, _configure.updateCaseSendTemplate)({
              id: _this5.currentId,
              caseBookId: realtedBookItem.id,
              templateName: _this5.temForm.name,
              smsTemplate: _this5.temForm.contentOfMess,
              emailTemplate: _this5.temForm.contentOfEmail,
              status: _this5.temForm.status == "启用" ? '1' : '0',
              caseState: caseItem.status,
              commId: committeeItem.id,
              commName: _this5.temForm.organ,
              partyType: partyTypeItem.id,
              sendFile: postFilelist.join()
            }).then(function (res) {
              if (res.code == 1) {
                _this5.$message({
                  message: '修改送达模板成功',
                  type: 'success'
                });
                _this5.temForm.sendType = '';
                _this5.templateVisible = false;
                _this5.$refs[formName].resetFields();
                _this5.resetTableList();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 文件上传处理
    handleRemove: function handleRemove(file, fileList) {
      var Index = (0, _index.findWithAttr)(this.fileList, 'uid', file.uid); //展示的文件列表
      this.fileList.splice(Index, 1);
    },
    handlePreview: function handlePreview(file) {
      if (file.url) {
        window.open(file.url);
      } else {
        var res = JSON.parse((0, _security.decryptByAES)(file.response.response, _encryptKey.encryptKey.key));
        if (res.code == 1) {
          window.open(res.data.href);
        } else {
          location.reload();
        }
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u5F53\u524D\u9650\u5236\u9009\u62E9 10 \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ".concat(files.length, " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ").concat(files.length + fileList.length, " \u4E2A\u6587\u4EF6"));
    },
    handleSuccess: function handleSuccess(res, file, fileList) {
      var res1 = JSON.parse((0, _security.decryptByAES)(res.response, _encryptKey.encryptKey.key));
      if (res1.code == 1) {
        this.fileList.push({
          name: res1.data.fileName,
          url: res1.data.href,
          uid: file.uid,
          filePath: res1.data.path
        });
      } else {
        location.reload();
      }
    },
    // 分页事件
    handleSizeChange: function handleSizeChange(val) {
      this.pageLimit = val;
      this.resetTableList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.resetTableList();
    }
  }
};
exports.default = _default;